export enum DamageTo {
  BUILDING = 'BUILDING',
  PROPERTY = 'PROPERTY',
  CLAIM = 'CLAIM',
}
